var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data":"basket-line-item-quantity"}},[_c('Dropdown',{attrs:{"disabled":_vm.disabled,"options":_setup.quantities,"value":_vm.quantity},on:{"onSelect":function($event){return _setup.onQuantityChange($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }